module.exports = __webpack_public_path__ + "img/btn_shitu_ding.2e4d1bd4.png";